export default "__VITE_ASSET__73fc3246__"